import { Layout } from '@osui/ui';
import React from 'react';
import classNames from 'classnames';
import './Content.less';
import { jsx as _jsx } from "react/jsx-runtime";
const {
  Content: OSUIContent
} = Layout;

const Content = ({
  children,
  className,
  fluid = true,
  tabsContent = false,
  ...rest
}) => {
  return /*#__PURE__*/_jsx(OSUIContent, {
    className: classNames('icloud-ui-page-layout-content', {
      'icloud-ui-page-layout-content-container': !fluid
    }, {
      'icloud-ui-page-layout-content-tabs-content': tabsContent
    }, className),
    ...rest,
    children: children
  });
};

export default Content;
//# sourceMappingURL=es/Content.js.map